<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="sert">M<span class="sm">ADE</span> <span class="sm">IN</span> M<span class="sm">ICHIGAN</span> W<span class="sm">RITERS</span> S<span class="sm">ERIES</span></p>
<p class="serahaft">G<span class="sm">ENERAL</span> E<span class="sm">DITORS</span></p>
<p class="sered">Michael Delp, Interlochen Center for the Arts</p>
<p class="sered">M. L. Liebler, Wayne State University</p>
<p class="serpf">A complete listing of the books in this series can be found online at <a class="url" href="http://www.wsupress.wayne.edu" target="_blank">wsupress.wayne.edu</a></p>
<p class="crtf">© 2019 by Wayne State University Press. All rights reserved. No part of this book may be reproduced without formal permission. Manufactured in the United States of America.</p>
<p class="crtf">ISBN 978-0-8143-4645-7 (paperback)</p>
<p class="crt">ISBN 978-0-8143-4646-4 (e-book)</p>
<p class="cipf">Library of Congress Control Number: 2018959986</p>
<p class="crtf">Publication of this book was made possible by a generous gift from The Meijer Foundation. This work is supported in part by an award from the Michigan Council for Arts and Cultural Affairs.</p>
<p class="crtf"><img alt="" height="100" src="images/mcaca-logo.jpg" width="112"/></p>
<p class="crtf">Wayne State University Press</p>
<p class="crt">Leonard N. Simons Building</p>
<p class="crt">4809 Woodward Avenue</p>
<p class="crt">Detroit, Michigan 48201–1309</p>
<p class="crtf">Visit us online at <a class="url" href="http://www.wsupress.wayne.edu" target="_blank">wsupress.wayne.edu</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wsu-ridl-0005.vue?689d1245